<template>
	<SimpleModal @close="closeModal">
		<div class="delete-modal-wrapper">
			<div class="new-team-wrapper no-margin">
				<div
					style="
						font-family: Avenir-Heavy;
						font-size: 20px;
						text-align: center;
						margin-top: 20px;
					"
				>
					<slot name="titletext"></slot>
				</div>
				<p
					style="text-align: center; font-family: Avenir-Book; font-size: 16px;"
				>
					<slot name="subtext"></slot>
				</p>
			</div>

			<div class="button-group">
				<button
					class="pronto-gray-pill-btn"
					style="height: 40px; width: 119px; margin-right: 12.5px;"
					@click="closeModal()"
					alt="cancel"
				>
					{{ $t('common_button_cancel') }}
				</button>
				<button
					v-if="!showSpinner"
					class="delete-modal-delete-button pronto-red-pill-btn save"
					style="height: 40px; width: 119px;"
					ref="deleteButton"
					@click="hideEvent()"
					data-cy="hideBtn"
				>
					{{ buttonText }}
				</button>

				<SpinnerOverlay
					style="position: relative; vertical-align: top;"
					v-if="showSpinner"
					:cTop="processSpinner.cTop"
					:cHeight="processSpinner.cHeight"
					:cLeft="processSpinner.cLeft"
					:cWidth="processSpinner.cWidth"
					:cBackground="processSpinner.cBackground"
					:cBorderRadius="processSpinner.cBorderRadius"
					:sWidth="processSpinner.sWidth"
					:sHeight="processSpinner.sHeight"
					:sMarginTop="processSpinner.sMarginTop"
					:sColor="processSpinner.sColor"
					:cBorder="processSpinner.cBorder"
					:zIndex="processSpinner.zIndex"
				/>
			</div>
		</div>
	</SimpleModal>
</template>

<script>
import { SimpleModal } from './common'
import SpinnerOverlay from './SpinnerOverlay'

export default {
	components: { SimpleModal, SpinnerOverlay },
	props: {
		buttonText: {
			default: 'Delete',
			type: String,
		},

		showSpinner: {
			default: false,
		},
	},

	data() {
		return {
			processSpinner: {
				cTop: null,
				cBottom: null,
				cLeft: null,
				cRight: null,
				cBackground: null,
				cBorderRadius: null,
				cBorder: null,
				sWidth: null,
				sHeight: null,
				sMarginTop: null,
				sColor: null,
				zIndex: null,
			},
		}
	},

	emits:['close', 'hide'],

	async mounted() {
		this.configureSpinner()

		await this.$nextTick()
		this.$refs.deleteButton.focus()
	},

	methods: {
		closeModal() {
			this.$emit('close')
		},

		hideEvent() {
			this.$emit('hide')
		},

		configureSpinner() {
			let element = document.querySelector('.delete-modal-delete-button')
			if (element) {
				let position = element.getBoundingClientRect()
				let style = getComputedStyle(element, null)
				this.processSpinner.cHeight = style.height
				this.processSpinner.cWidth = style.width
				this.processSpinner.cBackground = style.backgroundColor
				this.processSpinner.cBorderRadius = style.borderTopLeftRadius
				this.processSpinner.sHeight = '30px'
				this.processSpinner.sWidth = '30px'
				this.processSpinner.sMarginTop = (element.clientHeight - 30) / 2 + 'px'
				this.processSpinner.sColor = style.color
				this.processSpinner.cBorder =
					style.borderTopColor +
					' ' +
					style.borderTopStyle +
					' ' +
					style.borderTopWidth
				this.processSpinner.zIndex = 1111
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.delete-modal-wrapper {
	width: 450px;
	min-width: 450px;
	padding: 50px 50px 50px 50px;
}
.confirm-delete-margins {
	margin-top: 25px;
	margin-bottom: 25px;
}

.pronto-gray-pillb-btn,
.spinner-div {
	display: inline-block;
}

.save {
	background-color: var(--blue-300);
}

.save:hover {
	background-color: darken($pronto-blue, 8%);
	box-shadow: 0 2px 4px 0 rgba(45, 92, 120, 0.3);
}
.save:active {
	background-color: darken($pronto-blue, 11%);
	box-shadow: none;
}
</style>
